var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSgfPorePressureMeasurement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24,11h-3.065c-.217-1.961-1.071-3.864-2.571-5.364-3.509-3.51-9.219-3.51-12.728,0-1.5,1.5-2.353,3.403-2.571,5.364H0v2h3.065c.217,1.961,1.071,3.864,2.571,5.364,1.754,1.755,4.059,2.632,6.364,2.632s4.609-.877,6.364-2.632c1.5-1.5,2.353-3.403,2.571-5.364h3.065v-2ZM7.05,7.05c2.729-2.729,7.17-2.729,9.899,0,1.11,1.11,1.76,2.504,1.967,3.95H5.083c.207-1.446.858-2.84,1.967-3.95Zm9.899,9.9c-2.729,2.729-7.17,2.729-9.899,0-1.11-1.11-1.76-2.504-1.967-3.95h13.834c-.207,1.446-.858,2.84-1.967,3.95Z",
    fill: "#1c1c1b",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSgfPorePressureMeasurement);
export default __webpack_public_path__ + "static/media/icon-sgf-pore-pressure-measurement.e9eb6da641356e609dac96ced994592d.svg";
export { ForwardRef as ReactComponent };